import React from 'react'
import {
  compose,
  withState,
} from 'recompose'
import findIndex from 'lodash/findIndex'
import { updateObject } from 'helpers/objectHelpers'
import FormTextAlign from 'components/forms/FormTextAlign'
import ColumnWidthSelector from 'components/forms/ColumnWidthSelector'
import MainHeader from 'components/headers/MainHeader'
import { Divider } from 'semantic-ui-react'
import IconCustom from 'components/icon/IconCustom'
import { ColumnPanelIcons } from 'helpers/icons'
import Accordion from 'components/accordions/Accordion'
import { withSorter } from 'hocs/bases/withSorter'
import FormLabel from 'components/labels/FormLabel'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  createColumns,
  removeColumns,
} from 'store/canvas/actions'
import AppearanceToggle from 'components/forms/AppearanceToggle'
import muiThemeable from 'material-ui/styles/muiThemeable'

const mapDispatchToProps = (dispatch) => (
  bindActionCreators({
    createColumns,
    removeColumns,
  }, dispatch)
)

const ColumnEdit = ({
  value,
  value: {
    width = '',
    computer = '',
    tablet = '',
    mobile = '',
    only = '',
    textAlign = '',
    verticalAlign = '',
    stretched = false,
    floated = '',
  },
  device = '',
  onChange,
}) => {
  const handleChange = (val, key) => {
    return onChange(updateObject(value, { [key]: val }))
  }

  return (
    <div>
      <ColumnWidthSelector
        label="Width"
        value={value[device]}
        onChange={(val) => handleChange(val, device)}
        style={{ width: '100%' }}
      />
      {device === 'computer' && (
        <FormTextAlign
          value={textAlign}
          onChange={(val) => handleChange(val, 'textAlign')}
          style={{ width: '100%' }}
        />
      )}
      <FormLabel
        style={{
          paddingTop: 10,
          paddingBottom: 5,
        }}
      >
        Appearance
      </FormLabel>
      <AppearanceToggle
        device={device}
        value={only}
        onChange={(val) => handleChange(val, 'only')}
      />
    </div>
  )
}

const AccordionComponent = ({ children, style }) => (
  <div style={style}>
    {children}
  </div>
)
const ColumnIcon = compose(
  withSorter(),
  muiThemeable(),
)(
  ({
    item,
    index,
    onSelect,
    active,
    device,
    muiTheme: {
      palette: {
        accent1Color,
      },
    },
  }) => {
    const { defaultSettings } = item
    const widthCustom = (defaultSettings[device] * 100) / 12
    return (
      <div
        style={{
          zIndex: 10000,
          position: 'relative',
          padding: 10,
          border: '2px solid',
          borderRadius: 5,
          borderColor: active === index ? accent1Color : '#a5a5a5',
          margin: 10,
          width: `${widthCustom}%`,
          textAlign: 'center',
        }}
        onClick={() => onSelect(index)}
        role={'presentation'}
      >
        {defaultSettings[device]}
      </div>
    )
  },
)

const DeviceElement = ({
  elements,
  onChangeElements,
  setActiveIndex,
  activeIndex,
  handleUpdate,
  activeColumn,
  device,
  ColumnPanelIcons,
  label,
}) => {
  return (
    <div style={{ padding: 10 }}>
      {device !== 'mobile' && (
        <div style={{ display: 'flex' }}>
          <div style={{ margin: 10 }}>
            <img
              src={ColumnPanelIcons.iconHeader[device]}
              style={device === 'tablet' ? { width: 20 } : { width: 30 }}
            />
          </div>
          <MainHeader small fontWeight={900}>{label}</MainHeader>
        </div>
      )}
      <Accordion accordionProps={{ borderNotShow: true }}>
        <AccordionComponent
          label="Customize"
          subValue="customize"
        >
          <ColumnIcon
            collection={elements}
            onUpdate={onChangeElements}
            style={{
              display: 'flex',
              width: '100%',
            }}
            axis="x"
            onSelect={(val) => setActiveIndex(val)}
            active={activeIndex}
            device={device}
          />
          <ColumnEdit
            value={activeColumn.defaultSettings}
            onChange={(val) => handleUpdate(activeColumn, updateObject(activeColumn, { ['defaultSettings']: val }))}
            device={device}
          />
        </AccordionComponent>
      </Accordion>
    </div>
  )
}

const ColumnsSettings = compose(
  withState('activeIndex', 'setActiveIndex', 0),
  withState('activeGridIndex', 'setActiveGridIndex', ({ elements }) => {
    const columnsAmount = elements.length
    return findIndex(ColumnPanelIcons.gridOptions, ({ value }) => columnsAmount === value)
  }),
  withState('phoneActive', 'setPhoneActive', ({ valueSettings }) => (
    valueSettings.stackable ? 0 : 1
  )),
  connect(null, mapDispatchToProps),
)(({
  valueSettings,
  valueSettings: {
    // celled = false,
    // centered = false,
    // columns,
    // container = false,
    // divided = false,
    // doubling = false,
    // reversed,
    // stackable = true,
    // stretched = false,
    // textAlign,
    // verticalAlign,
  },
  onChangeSettings,
  valueDeviceSettings,
  valueDeviceSettings: {},
  onChangeDeviceSettings,
  activeIndex,
  setActiveIndex,
  elements = [],
  onChangeElements,
  updateElement = () => {},
  phoneActive,
  setPhoneActive,
  activeGridIndex,
  setActiveGridIndex,
  createColumns,
  element,
  removeColumns,
}) => {
  console.log('valueSettings', valueSettings)
  const handleChangeSettings = (val, key) => {
    return onChangeSettings(updateObject(valueSettings, { [key]: val }))
  }

  const handleUpdate = (element, val) => {
    return updateElement(updateObject(element, val))
  }

  const activeColumn = elements[activeIndex]

  return (
    <div>
      <div style={{ margin: 20 }}>
        <MainHeader small fontWeight={900}>Grid Options</MainHeader>
      </div>
      <Divider />
      <div
        style={{
          display: 'flex',
          padding: 10,
        }}
      >
        {ColumnPanelIcons.gridOptions.map((item, i) => {
          const { source, value } = item
          return (
            <IconCustom
              key={value}
              source={source}
              index={i}
              active={activeGridIndex}
              onClick={() => {
                if (activeGridIndex === i) {
                  return null
                }
                if (i < activeGridIndex) {
                  setActiveGridIndex(i)
                  return removeColumns({
                    amount: value,
                    element,
                    parentId: element.id,
                  }) // todo ลบ child
                }
                setActiveGridIndex(i)
                return createColumns({
                  amount: value,
                  element,
                  parentId: element.id,
                })
              }}
            />
          )
        })}
      </div>
      <DeviceElement
        elements={elements}
        onChangeElements={onChangeElements}
        setActiveIndex={setActiveIndex}
        activeIndex={activeIndex}
        handleUpdate={handleUpdate}
        activeColumn={activeColumn}
        device="computer"
        label="Desktop Layout"
        ColumnPanelIcons={ColumnPanelIcons}
      />
      <Divider />
      <DeviceElement
        elements={elements}
        onChangeElements={onChangeElements}
        setActiveIndex={setActiveIndex}
        activeIndex={activeIndex}
        handleUpdate={handleUpdate}
        activeColumn={activeColumn}
        device="tablet"
        label="Tablet Layout"
        ColumnPanelIcons={ColumnPanelIcons}
      />
      <Divider />
      <div style={{ padding: 10 }}>
        <div style={{ display: 'flex' }}>
          <div style={{ margin: 10 }}>
            <img alt={'icon'} src={ColumnPanelIcons.iconHeader.mobile} style={{ width: 16 }} />
          </div>
          <MainHeader small fontWeight={900}>Phone Layout</MainHeader>
        </div>
        <div
          style={{
            display: 'flex',
            padding: 10,
          }}
        >
          {ColumnPanelIcons.iconPhone.map((item, index) => {
            const { source } = item
            return (
              <IconCustom
                key={item.label}
                source={source}
                onClick={() => {
                  setPhoneActive(index)
                  if (index === 0) {
                    return handleChangeSettings(true, 'stackable')
                  }
                  return handleChangeSettings(false, 'stackable')
                }}
                index={index}
                active={phoneActive}
              />
            )
          })
          }
        </div>
        {phoneActive === 1 &&
        <DeviceElement
          elements={elements}
          onChangeElements={onChangeElements}
          setActiveIndex={setActiveIndex}
          activeIndex={activeIndex}
          handleUpdate={handleUpdate}
          activeColumn={activeColumn}
          device="mobile"
          ColumnPanelIcons={ColumnPanelIcons}
        />
        }
      </div>
    </div>
  )
})

ColumnsSettings.propTypes = {}
ColumnsSettings.defaultProps = {}

export default ColumnsSettings



// WEBPACK FOOTER //
// ./src/components/Canvas/builder/elementForms/columns/ColumnsSettings.js